if (Modernizr.csstransitions) {
	require('./helpers/request-animation-frame');

	$(document).on('click', '.accordeon__title', function() {
		var $content = $(this).next('.accordeon__content');
		var $state = $(this).prev('.accordeon__state');
		$content.off('.accordeon');

		if (!$state.prop('checked')) {
			$content.css('max-height', $content[0].scrollHeight);
		} else {
			$content.css('max-height', '0');
		}
	});
}

// adjust max-height after resize
var resizeTimer;
$(window).on('resize.accordeon', function(event) {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		$('.accordeon__state:checked + .accordeon__title + .accordeon__content').each(function() {
			if ($(this).css('max-height')) {
				$(this).css('max-height', this.scrollHeight);
			}
		});
	}, 100);
});
